import { ArrayUtil, Currency, UrlUtil } from "@mcleod/core";
import { AutogenLayoutSettlementList } from "./autogen/AutogenLayoutSettlementList";
import { DataSourceExecutionEvent, Label, TableRowDisplayEvent, Textbox } from "@mcleod/components";
import { DataLoadActionHandler } from "@mcleod/common";

export class SettlementList extends AutogenLayoutSettlementList {
    onLoad(): void | Promise<void> {
        this.tableSettlements.addRowDisplayListener(async (event: TableRowDisplayEvent) => {
            const tableRow = event.getTableRow();
            const labelOriginState = tableRow.findComponentById("labelOriginState") as Label;
            if (labelOriginState != null && !tableRow.data.isNull("origin_state")) {
                labelOriginState.text = ", " + tableRow.data.get("origin_state");
            }

            const labelDestinationState = tableRow.findComponentById("labelDestinationState") as Label;
            if (labelDestinationState != null && !tableRow.data.isNull("destination_state")) {
                labelDestinationState.text = ", " + tableRow.data.get("destination_state");
            }

            const settlementPay = tableRow.data.getCurrency("order_pay", new Currency(0));
            await settlementPay.add(tableRow.data.getCurrency("perdiem_pay", new Currency(0)));
            await settlementPay.add(tableRow.data.getCurrency("trailer_amt", new Currency(0)));
            await settlementPay.subtract(tableRow.data.getCurrency("preload_charge", new Currency(0)));
            tableRow.data.set("total_pay", settlementPay);
            (tableRow.findComponentById("textboxTotalPay") as Textbox)?.displayComponentData(tableRow.data, null, 0);
        });
    }

    sourceSettlementAfterExecution(event: DataSourceExecutionEvent) {
        this.handleDataLoadActions();
    }

    handleDataLoadActions() {
        const props = UrlUtil.getPropsFromUrl(window.location.href);
        if (props != null) {
            const dataLoadActionProps = DataLoadActionHandler.gatherFromUrlProps(props);
            if (ArrayUtil.isEmptyArray(dataLoadActionProps) === false) {
                DataLoadActionHandler.handleDataLoadActions(this, dataLoadActionProps, props);
            }
        }
    }
    
}
